import { trainingServe, staticImageUrl } from "@/utils/request";

const INSTRUCTOR = `/instructor/instructor/`;

const apiRequest = (method, data) => {
	return trainingServe({
		url: INSTRUCTOR,
		method: method,
		data,
	});
};
const getStaticImage = (name) => {
	return staticImageUrl({
		url: "user/static-image/?name=" + name,
		method: "GET",
	});
};

export { apiRequest, getStaticImage };
